<div class="export-mapping-modal">
  <div class="export-mapping-modal__picker">
    <label class="export-mapping-modal__label">
      <mat-icon>history</mat-icon>
      Select version to export
    </label>
    <mat-select [(ngModel)]="selectedVersion" [compareWith]="compareVersions">
      @for (v of versions; track v.version) {
        <mat-option [value]="v">{{ getVersionLabel(v) }}</mat-option>
      }
    </mat-select>
  </div>

  @if (selectedVersion) {
    <div class="export-mapping-modal__preview">
      <p class="export-mapping-modal__preview-label">
        <mat-icon>preview</mat-icon>
        Mapping preview
      </p>
      <pre class="export-mapping-modal__json">{{ previewJson }}</pre>
    </div>
  }
</div>
